import { AbstractControl } from '@angular/forms';
import { LocalTime } from './date.model';

export interface SelectOption<T = void, U = string, V = string> {
  value: T extends void ? string | number | LocalTime | null | V : keyof T;
  display: U;
  shortDisplay?: U;
  noTranslation?: boolean;
  disabled?: boolean;
}

export const NULL_SELECT_OPTION: SelectOption = {
  value: null,
  display: 'formSelect.nullSelectOption',
};

/** 1 = ASC, -1 = DESC */
export type SortDirection = 1 | -1;

export type AbstractControlObject<T> = {
  [K in keyof T]: AbstractControl<unknown>;
};
